class EventEmitter<T> {
  subscribers: ISubscribers<any> = {}
  isDebug = false

  on<A = T>(
    eventName: string, callback: (data: A) => void
  ): { unsubscribe: () => void} {
    if (!this.subscribers[eventName]) {
      this.subscribers[eventName] = []
    }
    const index = this.subscribers[eventName].push(callback) - 1

    return {
      unsubscribe: () => {
        this.subscribers[eventName].splice(index, 1)
      },
    }
  }

  emit(eventName: string, data: T): void {
    if (this.isDebug) {
      console.log(eventName, data)
    }

    const subscribers = this.getSubscribersByEventName(eventName)

    if (!subscribers.length) {
      return
    }

    subscribers.forEach(subscriberCallback =>
      subscriberCallback(data))
  }

  off(eventName: string, callbackToRemove: (data: T) => void): void {
    this.subscribers[eventName] = this.subscribers[eventName]
      .filter(callback => callback.toString() !== callbackToRemove.toString())
  }

  debug(): void {
    this.isDebug = true
  }

  protected getSubscribersByEventName(eventName: string): Array<(data: T) => void> {

    const ff = Object.keys(this.subscribers).reduce(
      (fd: Array<(data: T) => void>, subscriberName) => {
        if (areEventNamesEqual(eventName, subscriberName)) {
          return [...fd, ...this.subscribers[subscriberName]]
        }

        return fd
    }, [])

    return ff
  }
}

interface ISubscribers<T> {
  [key: string]: Array<(data: T) => void>;
}

export const areEventNamesEqual = (
  eventName: string,
  subscriberName: string
): boolean => {

  const asteriskIndex = subscriberName.indexOf('*')

  if (~asteriskIndex) {
    const subscriberNameBeforeWildcard = subscriberName.substr(0, asteriskIndex)

    if (~eventName.indexOf(subscriberNameBeforeWildcard)) {
      return true
    }
  }

  return eventName === subscriberName
}

export default EventEmitter

